// 官网相关的 layout，包含 header 和 footer
import Layout from '@/layout-portal/index.vue'
import Index from '@/views/index.vue'
import { RouteConfig } from 'vue-router'

const routes: RouteConfig[] = [
  {
    path: '/',
    component: Layout,
    meta: {},
    children: [
      {
        path: '/',
        meta: {
          title: '小拉出行'
        },
        name: 'Index',
        component: Index
      },
      {
        path: '/pricing',
        meta: {
          title: '计价说明'
        },
        name: 'Pricing',
        component: () =>
          import(/* webpackChunkName: "Pricing" */ '@/views/pricing.vue')
      },
      {
        path: '/agreement',
        meta: {
          title: '法律条款与平台规则',
          overflowY: true
        },
        name: 'Agreement',
        component: () =>
          import(/* webpackChunkName: "Agreement" */ '@/views/agreement.vue')
      }
    ]
  }
]

export default routes
